// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAOxYUz_4gjJA2jjtBdE5pTtoUe8OGwtUA",
  authDomain: "penguin-7c633.firebaseapp.com",
  projectId: "penguin-7c633",
  storageBucket: "penguin-7c633.appspot.com",
  messagingSenderId: "230092455274",
  appId: "1:230092455274:web:5f35e00fe70c39e1edf913",
  measurementId: "G-1L5ZP5ES6W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };